import * as PIXI from 'pixi.js';
export default (target, color, progress) => {
	const cm = target.activeCM || new PIXI.ColorMatrixFilter();

	// pixi v8 freezes the filters array, so rebuild it and reassign instead of mutating in place
	if(!target.filters?.includes(cm)) target.filters = [...(target.filters || []), cm];

	const r = (color >> 16) & 0xFF;
	const g = (color >>  8) & 0xFF;
	const b = color & 0xFF;

	cm.matrix = [
		0, 0, 0, 0, r / 256,
		0, 0, 0, 0, g / 256,
		0, 0, 0, 0, b / 256,
		0, 0, 0, 1, 0,
	];

	cm.alpha = progress;

	target.activeCM = cm;

	return cm;
}
